module.exports = __webpack_public_path__ + "media/images/icons/pie-chart-779102a8e227d56222b499cf2d22d4f4.svg";